import React, { useState } from "react";
// import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Components
import Layout from "../../../../Layout/Layout";

//Redux
import { InputField } from "../../../../Components/formElements/InputField";

const QuotationEstimateDetails = () => {
    localStorage.setItem("menu", "QuotationV4");
    localStorage.setItem("submenu", "");
    const [disabled, setDisabled] = useState(false);
    const components = [
        "Built Up Sections",
        "HR Secs. (Incl. Canam Joist/Girders)",
        "Cold Formed Sections (C & Z)",
        "Sheeting & Trims (Incl. Canam Decking)",
        "Tempcon Panels",
        "Clips, Cables, Rods, Bolts & Misc.",
        "Standard Accessories",
        "Insulation",
        "Standard/ Special Buyouts",
        "Special Works",
    ];
    const [rows, setRows] = useState(
        components.map(() => ({
            weightPercent: '',
            weightKG: '',
            pricePercent: '',
            priceINR: ''
        }))
    );
    // let combinedRows = rows.map((row, index) => ({
    //     component: components[index] || "", // add component name
    //     ...row
    // }));

    const [totalFields, setTotalFields] = useState({
        totalWeightPercent: '',
        totalWeightKG: '',
        totalPricePercent: '',
        totalPriceINR: ''
    });

    const [discountFields, setDiscountFields] = useState({
        weightPercent: '',
        weightKG: '',
        pricePercent: '',
        priceINR: ''
    });

    const [undiscountFields, setUndiscountFields] = useState({
        weightPercent: '',
        weightKG: '',
        pricePercent: '',
        priceINR: ''
    });

    const handleDiscountChange = (field, value) => {
        setDiscountFields((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleUndiscountChange = (field, value) => {
        setUndiscountFields((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const [formInputs, setFormInputs] = useState({
        quoteNo: '',
        jobNo: '',
        dsgn: '',
        chk: '',
        date1: '',
        revNo: '',
        date2: '',
    });

    const handleChange = (e) => {
        setFormInputs({
            ...formInputs,
            [e.target.name]: e.target.value,
        });
    };
    /* handle create */
    const handleCreate = async () => {
        // let obj = {
        //     ...formInputs,
        //     totalFields: totalFields,
        //     discountFields: discountFields,
        //     components: combinedRows,
        // };

    


        // const toastId = toast.loading("Loading...", {
        //     position: "top-right",
        // });
        // setDisabled(true);
        // await ItemService.createStock(obj).then((item) => {
        //     if (item?.status === 200) {
        //         modalData.successMsg = item?.message;
        //         setModalInfo(modalData);
        //         onSuccessfullyRegistered();
        //     } else {
        //         toast.error(item?.message || "Please try again !!", {
        //             duration: 4000,
        //             position: "top-right",
        //         });
        //     }
        // });
        // toast.dismiss(toastId);
        setDisabled(false);
    };


    // Handle row input changes
    const handleChangeRow = (index, field, value) => {
        const updated = [...rows];
        updated[index][field] = value;
        setRows(updated);
    };

    // Handle total row input changes
    const handleTotalChange = (field, value) => {
        setTotalFields(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <main className="dashboard main" id="main">
            <Layout />
            <Row className="justify-center subContent">
                <Col xs={12} md={12} className="rightSide">
                    <div className="container mt-3" style={{ fontSize: "13px" }}>
                        {/* Header */}
                        <div className="text-center text-danger fw-bold">eZ-Estimate Details</div>
                        <div className="text-center fw-bold mb-2">Job / Quotation Estimate Details</div>

                        {/* Top Right Version Table */}
                        <div className="d-flex justify-content-end mb-2">
                            <table className="table table-bordered table-sm text-center align-middle mb-3 fw-bold">
                                <tbody>
                                    <tr>
                                        <td className="text-start fw-bold">Quote No.</td>
                                        <td className="text-start">
                                            <InputField
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="quoteNo"
                                                value={formInputs.quoteNo}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>

                                        <td className="fw-bold">DSGN</td>
                                        <td className="fw-bold">CHK</td>
                                        <td className="fw-bold">Date</td>
                                        <td className="fw-bold">REV. No.</td>
                                        <td className="fw-bold">Date</td>
                                    </tr>

                                    <tr>
                                        <td className="text-start">Job No.</td>
                                        <td className="text-start">
                                            <InputField
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="jobNo"
                                                value={formInputs.jobNo}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>

                                        <td>
                                            <InputField
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="dsgn"
                                                value={formInputs.dsgn}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="chk"
                                                value={formInputs.chk}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="date"
                                                className="form-control form-control-sm"
                                                name="date1"
                                                value={formInputs.date1}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="revNo"
                                                value={formInputs.revNo}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="date"
                                                className="form-control form-control-sm"
                                                name="date2"
                                                value={formInputs.date2}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* Customer Info */}
                        <table className="table table-bordered table-sm mb-0 align-middle fw-bold">
                            <tbody>
                                <tr>
                                    <td className="text-start align-middle" style={{ padding: '4px 8px' }}>
                                        Customer Name
                                    </td>
                                    <td colSpan={9} style={{ padding: '4px 8px' }}>
                                        <InputField
                                            type="text"
                                            name="customerName"
                                            className="form-control form-control-sm"
                                            style={{ backgroundColor: '#eef4ff', padding: '4px 8px' }}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-start align-middle" style={{ padding: '4px 8px' }}>
                                        Project Name
                                    </td>
                                    <td colSpan={9} style={{ padding: '4px 8px' }}>
                                        <InputField
                                            type="text"
                                            name="projectName"
                                            className="form-control form-control-sm"
                                            style={{ backgroundColor: '#eef4ff', padding: '4px 8px' }}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {/*Building Area Quick Summary  */}
                        <div>
                            <table className="table table-bordered table-sm text-center align-middle mb-0 fw-bold">
                                <thead>
                                    <tr>
                                        <th colSpan={2} className="text-start fw-bold">
                                            Building Area Quick Summary
                                        </th>
                                        <th className="fw-bold">Width (m)</th>
                                        <th className="fw-bold">Len. (m)</th>
                                        <th className="fw-bold">E. H. (m)</th>
                                        <th className="fw-bold">Roof Slope<br />(×/10)</th>
                                        <th className="fw-bold">Roof Area (m²)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-start">Bldg. No.</td>
                                        <td className="text-start">
                                            <InputField
                                                type="text"
                                                name="bldgNo"
                                                className="form-control form-control-sm"
                                                value={formInputs.bldgNo}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="width"
                                                className="form-control form-control-sm"
                                                value={formInputs.width}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="length"
                                                className="form-control form-control-sm"
                                                value={formInputs.length}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="eaveHeight"
                                                className="form-control form-control-sm"
                                                value={formInputs.eaveHeight}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="roofSlope"
                                                className="form-control form-control-sm"
                                                value={formInputs.roofSlope}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="roofArea"
                                                className="form-control form-control-sm fw-bold text-center"
                                                value={formInputs.roofArea}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-start">Area No.</td>
                                        <td className="text-start">
                                            <InputField
                                                type="text"
                                                name="areaNo"
                                                className="form-control form-control-sm"
                                                value={formInputs.areaNo}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td colSpan={5}></td>
                                    </tr>

                                    <tr>
                                        <td className="text-start">Bay Spacing (m)</td>
                                        <td className="text-start" colSpan={6}>
                                            <InputField
                                                type="text"
                                                name="baySpacing"
                                                className="form-control form-control-sm"
                                                value={formInputs.baySpacing}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-start">Frame Type</td>
                                        <td className="text-start">
                                            <InputField
                                                type="text"
                                                name="frameType"
                                                className="form-control form-control-sm"
                                                value={formInputs.frameType}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td className="fw-bold">Live Load<br />(kN/m²)</td>
                                        <td className="fw-bold">Collateral<br />(kN/m²)</td>
                                        <td className="fw-bold">Snow<br />(kN/m²)</td>
                                        <td className="fw-bold" colSpan={2}>Wind Speed<br />(km/h)</td>
                                    </tr>

                                    <tr>
                                        <td className="text-start">No of Main Frames</td>
                                        <td className="text-start">
                                            <InputField
                                                type="number"
                                                name="mainFrames"
                                                className="form-control form-control-sm"
                                                value={formInputs.mainFrames}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="liveLoad"
                                                className="form-control form-control-sm"
                                                value={formInputs.liveLoad}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="collateral"
                                                className="form-control form-control-sm"
                                                value={formInputs.collateral}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="snow"
                                                className="form-control form-control-sm"
                                                value={formInputs.snow}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td colSpan={2}>
                                            <InputField
                                                type="number"
                                                name="windSpeed"
                                                className="form-control form-control-sm"
                                                value={formInputs.windSpeed}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-start">No of Post & Beam</td>
                                        <td className="text-start">
                                            <InputField
                                                type="number"
                                                name="postBeam"
                                                className="form-control form-control-sm"
                                                value={formInputs.postBeam}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td colSpan={5}></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/*  Weight Summary and  Pricing Summary */}
                        <div>
                            <table className="table table-bordered table-sm text-center align-middle mb-0 fw-bold">
                                <thead>
                                    <tr>
                                        <th colSpan={2} className="text-start fw-bold">
                                            Weight Summary
                                        </th>
                                        <th colSpan={3} className="text-start fw-bold">
                                            Pricing Summary
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-start">Total Weight (Kg)</td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="totalWeight"
                                                className="form-control form-control-sm text-center fw-bold"
                                                value={formInputs.totalWeight}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>Factory</td>
                                        <td>Currency</td>
                                        <td className="fw-bold">Discount %</td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">
                                            Weight (kg/m<sup>2</sup>)
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="weightPerSqm"
                                                className="form-control form-control-sm text-center fw-bold"
                                                value={formInputs.weightPerSqm}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="text"
                                                name="zsn"
                                                className="form-control form-control-sm text-center"
                                                value={formInputs.zsn}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="text"
                                                name="inr"
                                                className="form-control form-control-sm text-center"
                                                value={formInputs.inr}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="text"
                                                name="discount"
                                                className="form-control form-control-sm text-center fw-bold"
                                                value={formInputs.discount}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Painted Surface Area Summary and Total Book Price  */}
                        <div>
                            <table className="table table-bordered table-sm text-center align-middle mb-0 fw-bold">
                                <thead>
                                    <tr>
                                        <th colSpan={2} className="text-start fw-bold">Painted Surface Area Summary</th>
                                        <th className="text-start fw-bold">Total Book Price</th>
                                        {/* <th className="text-start fw-bold">#N/A</th> */}
                                        <td>
                                            <InputField
                                                type="number"
                                                name="primary"
                                                className="form-control form-control-sm"
                                                value={formInputs.primary}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-start">Primary (m<sup>2</sup>)</td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="primary"
                                                className="form-control form-control-sm"
                                                value={formInputs.primary}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td className="text-start">Book Price per m<sup>2</sup></td>
                                        <td>
                                            <InputField
                                                type="text"
                                                name="primaryBookPrice"
                                                className="form-control form-control-sm"
                                                value={formInputs.primaryBookPrice}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Secondary (m<sup>2</sup>)</td>
                                        <td>
                                            <InputField
                                                type="number"
                                                name="secondary"
                                                className="form-control form-control-sm"
                                                value={formInputs.secondary}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td className="text-start">Book Price per ton</td>
                                        <td>
                                            <InputField
                                                type="text"
                                                name="secondaryBookPrice"
                                                className="form-control form-control-sm"
                                                value={formInputs.secondaryBookPrice}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* Freight Information and Discounted Price */}
                        <div>
                            <table className="table table-bordered table-sm text-center align-middle mb-0 fw-bold">
                                <thead>
                                    <tr>
                                        <th colSpan={2} className="text-start fw-bold">Freight Information</th>
                                        <th colSpan={2} className="text-start fw-bold">Discounted Price</th>
                                        <th className="fw-bold">
                                            <InputField
                                                type="text"
                                                name="totalDiscount"
                                                className="form-control form-control-sm text-center"
                                                value={formInputs.totalDiscount}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-start">Destination</td>
                                        <td>
                                            <InputField
                                                type="text"
                                                name="destination"
                                                className="form-control form-control-sm"
                                                value={formInputs.destination}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td className="text-start">Discounted Price per m<sup>2</sup></td>
                                        <td>
                                            <InputField
                                                type="text"
                                                name="discountedPerM2"
                                                className="form-control form-control-sm text-center"
                                                value={formInputs.discountedPerM2}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Shipping Method</td>
                                        <td>
                                            <InputField
                                                type="text"
                                                name="shippingMethod"
                                                className="form-control form-control-sm"
                                                value={formInputs.shippingMethod}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td className="text-start">Discounted Price per ton</td>
                                        <td>
                                            <InputField
                                                type="text"
                                                name="discountedPerTon"
                                                className="form-control form-control-sm text-center"
                                                value={formInputs.discountedPerTon}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={3}>
                                            <InputField
                                                type="text"
                                                name="liftingMethod"
                                                className="form-control form-control-sm"
                                                value={formInputs.liftingMethod}
                                                onChange={handleChange}

                                                disabled={true}
                                            // placeholder="(Lifting Method) @ 0 INR To Destination City, Country"
                                            />
                                        </td>
                                        <td colSpan={2}>
                                            <InputField
                                                type="text"
                                                name="revisionNote"
                                                className="form-control form-control-sm text-end"
                                                value={formInputs.revisionNote}
                                                onChange={handleChange}
                                                // placeholder="2019 Price Book Rev. 4 - June 13th, 2019"
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="container mt-4" style={{ fontSize: "13px" }}>
                            <table className="table table-bordered table-sm text-center fw-bold">
                                <thead>
                                    <tr className="table-secondary fw-bold">
                                        <th rowSpan="2" className="align-middle">#</th>
                                        <th rowSpan="2" className="align-middle">Components Break Down</th>
                                        <th colSpan="2">Weight</th>
                                        <th colSpan="2">Price</th>
                                    </tr>
                                    <tr className="table-secondary fw-bold">
                                        <th>%</th>
                                        <th>KG</th>
                                        <th>%</th>
                                        <th>INR</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {components.map((comp, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td className="text-start">{comp}</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    value={rows[idx].weightPercent}
                                                    onChange={(e) => handleChangeRow(idx, 'weightPercent', e.target.value)}
                                                    disabled={true}

                                                />
                                            </td>
                                            <td>
                                                <InputField
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    value={rows[idx].weightKG}
                                                    onChange={(e) => handleChangeRow(idx, 'weightKG', e.target.value)}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td>
                                                <InputField
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    value={rows[idx].pricePercent}
                                                    onChange={(e) => handleChangeRow(idx, 'pricePercent', e.target.value)}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td>
                                                <InputField
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    value={rows[idx].priceINR}
                                                    onChange={(e) => handleChangeRow(idx, 'priceINR', e.target.value)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                    <tr className="fw-bold">
                                        <td colSpan="2" className="text-end">Total</td>

                                        <td>
                                            <InputField
                                                type="number"
                                                name="totalWeightPercent"
                                                className="form-control form-control-sm"
                                                value={totalFields.totalWeightPercent}
                                                onChange={(e) => handleTotalChange('totalWeightPercent', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>

                                        <td>
                                            <InputField
                                                type="number"
                                                name="totalWeightKG"
                                                className="form-control form-control-sm"
                                                value={totalFields.totalWeightKG}
                                                onChange={(e) => handleTotalChange('totalWeightKG', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>

                                        <td>
                                            <InputField
                                                type="number"
                                                name="totalPricePercent"
                                                className="form-control form-control-sm"
                                                value={totalFields.totalPricePercent}
                                                onChange={(e) => handleTotalChange('totalPricePercent', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>

                                        <td>
                                            <InputField
                                                type="number"
                                                name="totalPriceINR"
                                                className="form-control form-control-sm"
                                                value={totalFields.totalPriceINR}
                                                onChange={(e) => handleTotalChange('totalPriceINR', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>


                                    {/* Discountable Row */}
                                    {/* Total Discountable Row */}
                                    <tr>
                                        <td colSpan="2" className="text-end text-success fw-bold">Total Discountable</td>
                                        <td>
                                            <InputField
                                                type="number"
                                                className="form-control form-control-sm text-success"
                                                value={discountFields.weightPercent}
                                                onChange={(e) => handleDiscountChange('weightPercent', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={discountFields.weightKG}
                                                onChange={(e) => handleDiscountChange('weightKG', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                className="form-control form-control-sm text-success"
                                                value={discountFields.pricePercent}
                                                onChange={(e) => handleDiscountChange('pricePercent', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={discountFields.priceINR}
                                                onChange={(e) => handleDiscountChange('priceINR', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    {/* Total Undiscountable Row */}
                                    <tr>
                                        <td colSpan="2" className="text-end text-danger fw-bold">Total Undiscountable</td>
                                        <td>
                                            <InputField
                                                type="number"
                                                className="form-control form-control-sm text-danger"
                                                value={undiscountFields.weightPercent}
                                                onChange={(e) => handleUndiscountChange('weightPercent', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={undiscountFields.weightKG}
                                                onChange={(e) => handleUndiscountChange('weightKG', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                className="form-control form-control-sm text-danger"
                                                value={undiscountFields.pricePercent}
                                                onChange={(e) => handleUndiscountChange('pricePercent', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={undiscountFields.priceINR}
                                                onChange={(e) => handleUndiscountChange('priceINR', e.target.value)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </Col>
                <Row className="mb-2">
                    <Col
                        xs={2}
                        md={{ offset: 10, span: 1 }}
                        lg={{ offset: 10, span: 1 }}
                        className="text-right"
                    >
                        <span>
                            <button
                                className="btnTable"
                                disabled={disabled}
                                onClick={handleCreate}
                            >
                                Create
                            </button>
                        </span>
                    </Col>
                </Row>
            </Row>
        </main>
    );
};
export default QuotationEstimateDetails;
